import React from 'react';
import { Container, SkeletonHeader, SkeletonCard, SkeletonText, SkeletonChip } from './styles';

export default function SkeletonListaDemandas() {
  return (
    <Container>
      {[1, 2].map((dayIndex) => (
        <div key={dayIndex} style={{ marginBottom: '48px' }}>
          <SkeletonHeader>
            <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <SkeletonText width="40px" height="14px" />
                <SkeletonText width="32px" height="32px" />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <SkeletonText width="200px" height="20px" />
                <SkeletonText width="120px" height="16px" />
              </div>
            </div>
          </SkeletonHeader>
          
          <div style={{
            padding: '16px 12px 0 12px',
            paddingTop: '0'
          }}>
            {[1, 2].map((cardIndex) => (
              <SkeletonCard key={cardIndex}>
                <div style={{
                  padding: '16px 12px',
                  borderBottom: '1px solid #f3f4f6'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                    <SkeletonText width="150px" height="16px" />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: '12px' }}>
                      <SkeletonChip width="60px" height="24px" />
                      <SkeletonChip width="80px" height="24px" />
                      <SkeletonChip width="100px" height="24px" />
                    </div>
                    <SkeletonText width="100px" height="16px" />
                  </div>
                </div>
                
                <div style={{
                  padding: '16px 12px'
                }}>
                  <div style={{ display: 'flex', gap: '32px' }}>
                    <div style={{ flex: 1 }}>
                      <SkeletonText width="80px" height="12px" marginBottom="8px" />
                      <SkeletonText width="120px" height="14px" />
                    </div>
                    <div style={{ flex: 1 }}>
                      <SkeletonText width="80px" height="12px" marginBottom="8px" />
                      <SkeletonText width="140px" height="14px" />
                    </div>
                  </div>
                </div>
              </SkeletonCard>
            ))}
          </div>
        </div>
      ))}
    </Container>
  );
}
